var Util = {
	getSearch: function(key) {
		return new RegExp('[&?]' + key + '=([^&]*)', 'i').test(location.search) ? decodeURIComponent(RegExp.$1) : '';
	},
	isNull: function(a) {
		return typeof a == "object" && !a;
	},
	getUrlParam: function(url, parameter) {
		url = url || location.href;
		var result = url.match(new RegExp("[\#|\?]([^#]*)[\#|\?]?"));
		url = "&" + (this.isNull(result) ? "" : result[1]);
		result = url.match(new RegExp("&" + parameter + "=", "i"));
		return this.isNull(result) ? undefined : url.substr(result.index + 1).split("&")[0].split("=")[1];
	},
	initEvents: function(Events) {
		var key, keyArr, delElems, elems, events;
		var spiltElems = function(elems) {
			return elems.split('&').join(',');
		}
		for (key in Events) {
			keyArr = key.split('|');
			switch (keyArr.length) {
				case 3:
					delElems = spiltElems(keyArr[0]);
					elems = spiltElems(keyArr[1]);
					events = spiltElems(keyArr[2]);
					delElems = document;
					$(delElems).on(events, elems, Events[key]);
					break;
				case 2:
					elems = spiltElems(keyArr[0]);
					events = spiltElems(keyArr[1]);
					$(elems).on(events, Events[key]);
					break;
				default:
					break;
			}
		}
	}
};
module.exports = Util;



//////////////////
// WEBPACK FOOTER
// ./src/common/util.js
// module id = 3
// module chunks = 0